/**
 * Session token storage — sicurezza migliorata (batch C code review):
 *
 * Prima usavamo `localStorage`. Ora usiamo `sessionStorage`:
 *   - il token si cancella quando l'utente chiude la scheda del browser
 *   - non è condiviso tra tab (riduce l'esposizione XSS su tab compromesse)
 *   - non è persistente sul disco (più difficile per altri utenti dello stesso PC)
 *
 * Migrazione: se troviamo un vecchio token in localStorage lo spostiamo automaticamente
 * a sessionStorage e lo cancelliamo da localStorage, per non buttar giù le sessioni
 * degli utenti già loggati.
 *
 * NB: Prossimo step (Batch B dedicato): passare a httpOnly cookies via backend.
 */

const LEGACY_KEY = "burofacile_token";
const KEY = "tuotax_session_token";

let migrated = false;

function migrateOnce() {
  if (migrated) return;
  migrated = true;
  try {
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy && !sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, legacy);
    }
    if (legacy) {
      localStorage.removeItem(LEGACY_KEY);
    }
  } catch { /* private mode / disabled storage */ }
}

export function getToken() {
  migrateOnce();
  try {
    return sessionStorage.getItem(KEY);
  } catch { return null; }
}

export function setToken(token) {
  migrateOnce();
  try {
    if (!token) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, token);
  } catch { /* storage disabled */ }
}

export function clearToken() {
  migrateOnce();
  try {
    sessionStorage.removeItem(KEY);
    // Migrazione: cancella anche vecchia chiave se esistente
    localStorage.removeItem(LEGACY_KEY);
  } catch { /* ignore */ }
}
